// Banear o desbanear una cuenta (ventana común de Usuarios y de la ficha de cuenta).
import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../../pages/admin/shared';

/**
 * banModal: { username, isBanned, banReason }
 * onClose(): cerrar sin hacer nada · onDone(): tras banear/desbanear (recargar datos)
 */
export default function BanDialog({ banModal, onClose, onDone, showFeedback }) {
  const [banReason, setBanReason] = useState('');
  const [banDays, setBanDays]     = useState('0');
  const [banLoading, setBanLoading] = useState(false);

  const handleBanAction = async () => {
    setBanLoading(true);
    try {
      if (banModal.isBanned) {
        await axios.post(`${BACKEND_URL}/api/admin/accounts/${encodeURIComponent(banModal.username)}/unban`, {}, { withCredentials: true });
        showFeedback('ok', `Cuenta ${banModal.username} desbaneada correctamente.`);
      } else {
        await axios.post(
          `${BACKEND_URL}/api/admin/accounts/${encodeURIComponent(banModal.username)}/ban`,
          { reason: banReason.trim() || 'Baneado por admin', duration_days: parseInt(banDays, 10) || 0 },
          { withCredentials: true }
        );
        const durLabel = banDays === '0' ? 'permanentemente' : `por ${banDays} días`;
        showFeedback('ok', `Cuenta ${banModal.username} baneada ${durLabel}.`);
      }
      onDone();
    } catch (err) {
      showFeedback('err', err?.response?.data?.detail || 'Error al procesar el ban.');
    } finally {
      setBanLoading(false);
    }
  };

  return (
    <div data-testid="ban-dialog" style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'rgba(5,15,35,0.99)', border: '1px solid rgba(0,229,255,0.25)', borderRadius: 14, padding: '28px 32px', maxWidth: 420, width: '90%' }}>
        <p style={{ color: 'rgba(224,247,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: 1.5, margin: '0 0 10px' }}>
          {banModal.isBanned ? 'DESBANEAR CUENTA' : 'BANEAR CUENTA'}
        </p>
        <p style={{ color: '#e0e8f0', fontSize: 15, fontWeight: 700, margin: '0 0 16px' }}>
          {banModal.username}
        </p>

        {banModal.isBanned ? (
          <p style={{ color: 'rgba(224,247,255,0.5)', fontSize: 13, margin: '0 0 22px' }}>
            Motivo actual: <span style={{ color: '#fbbf24' }}>{banModal.banReason || '—'}</span>
            <br />¿Confirmas que quieres desbanear esta cuenta?
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 22 }}>
            <div>
              <label style={{ color: 'rgba(224,247,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: 1, display: 'block', marginBottom: 6 }}>MOTIVO</label>
              <textarea
                value={banReason}
                onChange={e => setBanReason(e.target.value)}
                placeholder="Motivo del ban..."
                rows={6}
                style={{ width: '100%', boxSizing: 'border-box', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(0,229,255,0.2)', borderRadius: 8, padding: '9px 12px', color: '#e0e8f0', fontSize: 13, fontFamily: 'inherit', resize: 'vertical', lineHeight: 1.5 }}
              />
            </div>
            <div>
              <label style={{ color: 'rgba(224,247,255,0.5)', fontSize: 11, fontWeight: 700, letterSpacing: 1, display: 'block', marginBottom: 6 }}>DURACIÓN</label>
              <select
                value={banDays}
                onChange={e => setBanDays(e.target.value)}
                style={{ width: '100%', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(0,229,255,0.2)', borderRadius: 8, padding: '9px 12px', color: '#e0e8f0', fontSize: 13, fontFamily: 'inherit' }}
              >
                <option value="0">Permanente</option>
                <option value="1">1 día</option>
                <option value="7">7 días</option>
                <option value="30">30 días</option>
                <option value="90">90 días</option>
              </select>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} disabled={banLoading}
            style={{ padding: '9px 18px', borderRadius: 8, fontSize: 13, fontWeight: 600, background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', color: 'rgba(224,247,255,0.5)', cursor: 'pointer' }}>
            Cancelar
          </button>
          <button onClick={handleBanAction} disabled={banLoading}
            style={{ padding: '9px 20px', borderRadius: 8, fontSize: 13, fontWeight: 700, background: banModal.isBanned ? 'rgba(52,211,153,0.12)' : 'rgba(248,113,113,0.12)', border: `1px solid ${banModal.isBanned ? 'rgba(52,211,153,0.35)' : 'rgba(248,113,113,0.35)'}`, color: banModal.isBanned ? '#34d399' : '#f87171', cursor: banLoading ? 'not-allowed' : 'pointer' }}>
            {banLoading ? 'Procesando...' : banModal.isBanned ? 'Desbanear' : 'Banear'}
          </button>
        </div>
      </div>
    </div>
  );
}
